/*
 * This is the initial API interface
 * we set the base URL for the API
 */
import Vue from 'vue';
import axios from 'axios';
import { useAuthStore } from '@services/pinia/AuthStore';

const apiClient = axios.create({
    baseURL: '/',
    withCredentials: true, // required to handle the CSRF token
});

/*
 * Add a response interceptor
 */
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;

        const store = useAuthStore();

        if ([401, 419].includes(status) && store.user) {
            // eslint-disable-next-line no-undef
            Vue.swal({
                icon: 'warning',
                title: 'Session har förfallit!',
                text: 'Logga in på nytt för att fortsätta.',
                reverseButtons: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
            }).then(() => {
                store.resetAndRedirect();
            });
        } else if ([403].includes(status)) {
            Vue.swal({
                icon: 'warning',
                title: 'Obehörig!',
                text: 'Du har inte rättigheter att utföra denna åtgärd.',
                reverseButtons: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
            });
        } else if (status >= 300 && status !== 404 && status !== 422) {
            const { data } = error.response;
            let message = 'Oops... Något gick fel...';
            if (data.message) {
                message = data.message;
            }
            Vue.swal({
                icon: 'error',
                title: 'Error!',
                text: message,
                reverseButtons: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Avbryt',
            });
        }

        return Promise.reject(error);
    },
);

export default apiClient;
